export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];
export const MONTH_OPTIONS =
  MONTHS.map((month) => ({value: month, label: month}));

export const YEAR_OPTIONS = () => {
  const years = [];
  const minYear = new Date().getFullYear() - 1960;
  for (let i = 0; i <= minYear; i++) {
    years.push({
      value: new Date().getFullYear() - i,
      label: new Date().getFullYear() - i
    });
  }
  return years;
}
